import type { AppLocale } from './types';

export function applyDocumentLocale(locale: AppLocale): void {
  document.documentElement.lang = locale;
}
